export const PARTNER_CONCESSIONAIRE_NAMES = [
  "SP Serra - Via Appia",
  "CNL - Concessionária Novo Litoral",
  "CSG - Caminhos da Serra Gaúcha",
  "Via Campo",
];

export const TAG_CHECKOUT_URL =
  "http://semparar.com.br/on/demandware.store/Sites-SemParar-Site/default/Cart-ExternalBuyNow?pid=004P-LIVRE-MANUAL-FREEFLOW-PARCERIAS";
